import { render } from "./NewColisListe.vue?vue&type=template&id=6810c8b4&ts=true"
import script from "./NewColisListe.vue?vue&type=script&lang=ts"
export * from "./NewColisListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__